import ReactOnRails from 'react-on-rails/client';
import ContactsPage from '../../app/ContactsPage.jsx';

ReactOnRails.register({ContactsPage});